<script>
    import { loggedInUserStore } from "./../store/loggedInUser.js";
    import { langTextStore } from "./../store/langtexts.js";
    import { countryStore } from "./../store/countries.js";
    import { factoryStore } from "../store/factories.js";
    let factory = {};

    let jsonString;
    async function createProduct() {
        let productSetting = JSON.parse(jsonString);
        productSetting.countryId = factory.countryId;
        productSetting.userId = $loggedInUserStore.uuid;
        productSetting.changeDate = new Date().toJSON();
        factory.name = productSetting.factoryName;
        factory.changeDate = new Date().toJSON();
        factory.userId = $loggedInUserStore.uuid;
        let factoryId = await factoryStore.saveFactory(factory);
        var factorySetting = { ...productSetting };
        factorySetting.changeDate = new Date().toJSON();
        factorySetting.factoryId = factoryId;
        factorySetting.uuid = null;
        factorySetting.factorySettingId = null;
        var factorySettingId = await factoryStore.saveFactoryOrProductSettings(
            factorySetting
        );
        productSetting.uuid = null;
        productSetting.factoryId = factoryId;
        productSetting.factorySettingId = factorySettingId;
        var factorySettingId = await factoryStore.saveFactoryOrProductSettings(
            productSetting
        );
        alert("done");

        window.open("/");
    }
</script>

<label for="fixedId">{$langTextStore.getText("general-label-country")} </label>
<select
    bind:value={factory.countryId}
    class="form-control mb-3"
    placeholder="asd"
>
    <option>{$langTextStore.getText("general-label-choose-a-country")}</option>
    {#each $countryStore as country}
        <option value={country.id}>{country.nameKey} </option>
    {/each}
</select>

<label>JSON Content</label>
<textarea bind:value={jsonString} />

<button on:click={createProduct}>create product</button>
